<template>
  <card-to-mobile-layout title="For this holiday break I will be...">
    <div class="row">
      <div class="col-12">
        <base-radio
          :model-value="modelValue"
          label="For this holiday break I will be..."
          :field-options="{
            hideLabel: true,
          }"
          name="holidayPlans"
          :options="options"
          :form-name="formName"
          :rules="rules.holidayPlans"
          @update:model-value="$emit('update:modelValue', $event as Model)"
        />
      </div>
    </div>
  </card-to-mobile-layout>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { Rules } from "../useValidations";

type Model = null | "E" | "S" | "H" | "T";

interface Props {
  modelValue: Model;
  formName: string;
  rules: Rules;
  leaveOptions: {
    stay: boolean;
    home: boolean;
    other: boolean;
    temporary: boolean;
  };
}

const props = defineProps<Props>();

type Emits = {
  (e: "update:modelValue", payload: Model): void;
};

defineEmits<Emits>();

const options = computed(() =>
  [
    { show: props.leaveOptions.stay, label: "Staying in the dorm", value: "S" },
    { show: props.leaveOptions.home, label: "Going home", value: "H" },
    {
      show: props.leaveOptions.home,
      label: "Requesting temporary housing on campus for the entire break",
      value: "T",
    },
    {
      show: props.leaveOptions.other,
      label: "Going somewhere else (enter address below)",
      value: "E",
    },
  ].filter((x) => x.show)
);
</script>
